import JWPlayer from "@/shared/components/JWPlayer/index.js";

const Video = (props) => {
  const {
    thumbnail,
    videoFiles,
    entityId
  } = {...props.content};
  
  const videoStreamingUrl = videoFiles?.m3u8;
  return (
    <div style={{margin: '1rem 0px 0px 0px' }}>
        <JWPlayer playerId={entityId} thumbnail={thumbnail} file={videoStreamingUrl} playerScript="https://cdn.jwplayer.com/libraries/ogkm6Oc3.js"/>
    </div>
  );
}

export default Video;